import {EAppUserType} from '../Data/Data';
import {AuthenticationService} from './AuthenticationService';
import {StateService} from 'angular-ui-router';

export class NavigationService {
  static serviceId = 'NavigationService';
  static $inject = [
    '$window',
    '$state',
    AuthenticationService.serviceId
  ];

  constructor(private $window: ng.IWindowService,
              private $state: StateService,
              private authentication: AuthenticationService) {

  }

  goToMenu() {
    if (!this.authentication.appUser) {
      return this.$state.transitionTo('login');
    }

    if (this.authentication.appUser.appUserType === EAppUserType.Terminal) {
      this.$state.transitionTo('terminal-home');
    } else if (this.authentication.appUser.appUserType === EAppUserType.Personal) {

      if (this.authentication.appUser.mustResetPassword) {
        this.$state.transitionTo('settings', {forced: true});
      } else {
        this.$state.transitionTo('person-home');
      }


    } else {
      this.$state.transitionTo('login');
    }
  }

  goToState(state: string, args?: any) {
    this.$state.transitionTo(state, args);
  }
}